/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum BaseTableInputType {
    READONLY = 0,
    TEXT = 1,
    NUMBER = 2,
    CHECKBOX = 3,
    DATE_PICKER = 4,
    SELECT = 5,
    TAGS = 6,
    CHIPS = 7,
    LINK = 8,
    PHONE = 9,
    SSN = 10,
    EMAIL = 11,
    CURRENCY = 12,
    PHONE_AND_EXTENSION = 13,
    INDICATION = 14,
    OPTIONS = 15,
    AUTOCOMPLETE = 16,
    DECIMAL = 17,
    DOWNLOAD_LINK = 18,
    PLUS_MINUS = 19,
    READONLY_CHECKBOX = 20,
    READONLY_SELECT = 21,
    CONDITIONAL_RADIO_BUTTON = 22,
    TEXT_BOLD = 23,
    INPUT_WITH_ICON = 24,
    MULTI_SELECTION = 25,
    HTML_ELEMENT = 26,
    TOOLTIP = 27,
    BOLD = 28,
}
